import React from 'react';
import { Container, Line } from './WidgetSkeleton.styled';

/**
 * Skeleton de carga para un widget.
 * Se muestra mientras se obtienen los datos.
 */
const WidgetSkeleton = () => {
  return (
    <Container>
      <Line $width="60%" />
      <Line />
      <Line />
      <Line $width="80%" />
    </Container>
  );
};

export default WidgetSkeleton;
